module.exports = __webpack_public_path__ + "img/chris-red.da00b5c5.svg";